import {updateObjectRecord} from '../integration/ObjectManager.js';
import {logAction} from '../integration/Api.js';
import keycloak from "../authentication/Keycloak.js";
import dayjs from "dayjs";
import {enUS} from '@mui/x-date-pickers/locales';
import {fiFI} from '@mui/x-date-pickers/locales';
import {ptBR} from '@mui/x-date-pickers/locales';

const file='Utilities.js';
function getTabId(){
    if(!window.name){
        window.name=crypto.randomUUID();
        sessionStorage.setItem("logCounter",0);
    }
    return window.name;
}
const tabId=getTabId();
let logCounter=parseInt(sessionStorage.getItem("logCounter")||"0",10)
export const consoleLog=(args)=>{
    if(keycloak?.idTokenParsed?.enableFrontEndConsoleLog==='true'||keycloak?.idTokenParsed?.enableFrontEndConsoleLogOnUI==='true'){
        const log={...args,path:window.location.pathname,timestamp:new Date().toISOString(),sequence:logCounter,tabId:tabId};
        if(keycloak?.idTokenParsed?.enableFrontEndConsoleLogOnUI==='true'){
            console.log(log);
        }
        if(keycloak?.idTokenParsed?.enableFrontEndConsoleLog==='true'){
            let log_bkp=JSON.parse(JSON.stringify(log));
            log_bkp.arg_value=normalizeArgValue(log_bkp.arg_value);
            logAction(log_bkp);
            logCounter++;
            sessionStorage.setItem("logCounter",logCounter);
        }
    }
};

export const getCookie=(name)=>{
  const value=`; ${document.cookie}`;
  const parts=value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

const normalizeArgValue=(arg_value)=>{
    if (typeof arg_value==="object") {
        arg_value=JSON.stringify(arg_value);
    } 
    else if (typeof arg_value==="boolean"||typeof arg_value==="number"){
        arg_value = String(arg_value);
    } 
    else if (arg_value===null||arg_value===undefined){
        arg_value = "NULL";
    }

    if (typeof arg_value!=="string"){
        arg_value=String(arg_value);
    }

    return arg_value.length>2000?arg_value.substring(0,2000):arg_value;
}

export const getWeekDayName=(date)=>{
    const days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    return days[date.getDay()];
}

export const addTimeStrToDateStr=(dateStr,timeStr)=>{
    const date=new Date(dateStr);
    const [hours,minutes]=timeStr.split(':').map(Number);
    date.setHours(hours);
    date.setMinutes(minutes);
    return date;
}

export const getPreviousMonthDates=()=>{
    const now=new Date();
    const firstDayLastMonth=new Date(now.getFullYear(),now.getMonth()-1,1);
    const lastDayLastMonth=new Date(now.getFullYear(),now.getMonth(),0);
    return{
        start_date:firstDayLastMonth,
        end_date:lastDayLastMonth
    };
};

export const getISOWeekNumber=(date)=>{
    const tempDate=new Date(date);
    tempDate.setHours(0,0,0,0);
    const dayOfWeek=(tempDate.getDay()+6)%7;
    tempDate.setDate(tempDate.getDate()-dayOfWeek+3);
    const firstThursday=new Date(tempDate.getFullYear(),0,4);
    const firstDayOfISOYear=new Date(firstThursday);
    firstDayOfISOYear.setDate(firstThursday.getDate()-((firstThursday.getDay()+6)%7));
    const diffInDays=(tempDate-firstDayOfISOYear)/86400000;
    const weekNumber=Math.ceil((diffInDays+1)/7);
    return weekNumber===-0?1:weekNumber;
}

export const getLastWeekNumber=(year)=>{
    const lastDayOfYear=new Date(year,11,31);
    const dayOfWeek=lastDayOfYear.getDay();
    const thursdayOffset=dayOfWeek===0?-3:dayOfWeek<=4?-dayOfWeek+4:4-dayOfWeek;
    const lastThursday=new Date(lastDayOfYear);
    lastThursday.setDate(lastDayOfYear.getDate()+thursdayOffset);
    if(lastThursday.getFullYear()!==year){
        const lastThursdayOfPreviousWeek=new Date(lastThursday);
        lastThursdayOfPreviousWeek.setDate(lastThursday.getDate()-7);
        return getISOWeekNumber(lastThursdayOfPreviousWeek);
    }
    return getISOWeekNumber(lastThursday);
}

export const getMondayAndFridayByISOWeek=(weekNumber,year)=>{
    const today=new Date();
    const fourthJan=new Date(year,0,4);
    const dayOfWeek=(fourthJan.getDay()+6)%7;
    const firstMonday=new Date(fourthJan);
    firstMonday.setDate(fourthJan.getDate()-dayOfWeek);
    const monday=new Date(firstMonday);
    monday.setDate(firstMonday.getDate()+(weekNumber-1)*7);
    const tuesday=new Date(monday);
    tuesday.setDate(monday.getDate()+1);
    const wednesday=new Date(monday);
    wednesday.setDate(monday.getDate()+2);
    const thursday=new Date(monday);
    thursday.setDate(monday.getDate()+3);
    const friday=new Date(monday);
    friday.setDate(monday.getDate()+4);
    let weekDayToday='Weekend';
    switch(today.setHours(0,0,0,0)){
        case monday.setHours(0,0,0,0):
            weekDayToday='Mon';
            break;
        case tuesday.setHours(0,0,0,0):
            weekDayToday='Tue';
            break;
        case wednesday.setHours(0,0,0,0):
            weekDayToday='Wed';
            break;
        case thursday.setHours(0,0,0,0):
            weekDayToday='Thu';
            break;
        case friday.setHours(0,0,0,0):
            weekDayToday='Fri';
            break;
        default:
            weekDayToday='Mon';
    }
    return {Mon:monday,Tue:tuesday,Wed:wednesday,Thu:thursday,Fri:friday,WeekDayToday:weekDayToday};
}

export const formatMinutesToHHMM=(totalMinutes)=>{
    if(!totalMinutes||totalMinutes<=0){
        return "00:00"; 
    }
    const hours=Math.floor(totalMinutes/60);
    const minutes=totalMinutes%60;
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

export const isNewYearInSameWeek=(today)=>{
  const currentYear=today.getFullYear();
  const startOfWeek=new Date(today);
  startOfWeek.setDate(today.getDate()-today.getDay()+1);
  const endOfWeek=new Date(today);
  endOfWeek.setDate(today.getDate()-today.getDay()+7);
  const newYearsDay=new Date(currentYear+1,0,1);
  return newYearsDay>=startOfWeek&&newYearsDay<=endOfWeek;
}

export const formatTime=(dateString)=>{
    const date=new Date(dateString);
    const hours=date.getHours().toString().padStart(2,'0');
    const minutes=date.getMinutes().toString().padStart(2,'0');
    return `${hours}:${minutes}`;
}

export const adjustDateLocale=(date_to_be_formatted,noTime=false)=>{
    if(noTime===undefined){noTime=false;}
    if(date_to_be_formatted===null||date_to_be_formatted===''||date_to_be_formatted===undefined){
        return '';
    }
    else{
        const formatted_date=new Date(date_to_be_formatted);
        if(noTime){
            formatted_date.setHours(0,0,0,0);
            return formatted_date.toLocaleDateString('fi-FI',{year:'numeric',month:'numeric',day:'numeric'});
        }
        else{
            return formatted_date.toLocaleString('fi-FI',{timeZone:'EET'});
        }
    }
}

export const dayjs_to_ui=(value)=>{
    let day=String(value.$D).length>1?String(value.$D):'0'+String(value.$D);
    let month=String(value.$M+1).length>1?String(value.$M+1):'0'+String(value.$M+1);
    return day+'/'+month+'/'+String(value.$y);
}

export const currentTimestamp=()=>{
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export const dateFns_to_db=(date)=>{
    let month=String(date.getMonth()+1).length>1?String(date.getMonth()+1):'0'+String(date.getMonth()+1);
    let day=String(date.getDate()).length>1?String(date.getDate()):'0'+String(date.getDate());
    let year=date.getFullYear();
    return year+'-'+month+'-'+day;
}
export const dateFns_to_ui=(date)=>{
    let month=String(date.getMonth()+1).length>1?String(date.getMonth()+1):'0'+String(date.getMonth()+1);
    let day=String(date.getDate()).length>1?String(date.getDate()):'0'+String(date.getDate());
    let year=date.getFullYear();
    return day+'.'+month+'.'+year;
}

export const dayjs_to_db=(value)=>{
    let day=String(value.$D).length>1?String(value.$D):'0'+String(value.$D);
    let month=String(value.$M+1).length>1?String(value.$M+1):'0'+String(value.$M+1);
    return String(value.$y)+'-'+month+'-'+day;
}

export const dayjs_to_db_with_time=(value)=>{
   return value.format('YYYY-MM-DD HH:mm:ss');
}

export const saveUserDataGridParams=(dataGridParams,user_id)=>{
    const update={datagrid_params:dataGridParams};
    updateObjectRecord({entityType:'SystemUser',entityId:user_id,entityData:update,getUpdatedRecord:false})
    .then((data)=>{
        consoleLog({file:file,context:'saveUserDataGridParams - updateObjectRecord',arg_name:'data',arg_value:data});
    });
}

export const listGridUpdated=(dataGridParams,list_name,field,width)=>{
    let dataGridParamsNew=JSON.parse(JSON.stringify(dataGridParams));
    if(!(list_name in dataGridParamsNew)){
        dataGridParamsNew[list_name]={};
    }
    if(field in dataGridParamsNew[list_name]){
        dataGridParamsNew[list_name][field].width=parseFloat(width.toFixed(2))
    }
    else{
        dataGridParamsNew[list_name][field]={width:parseFloat(width.toFixed(2))}
    }
    return dataGridParamsNew;
}

export const DefaultConfig={
    readOnlyBackgroundColor:'#d3d3d354'
}

export const time_to_ui=(value)=>{
    let hour=String(value.$H).length>1?String(value.$H):'0'+String(value.$H);
    let minute=String(value.$m+1).length>1?String(value.$m):'0'+String(value.$m);
    return hour+':'+minute;
}

export const appendUrlWithBodyParams=(url,body)=>{
    let updated_url=url;
    if("entityParams" in body){
        if(Array.isArray(body.entityParams)&&body.entityParams.length>0){
            const params=new URLSearchParams();
            body.entityParams.forEach((param)=>{
                const eqIndex=param.indexOf('=');
                if(eqIndex===-1){
                    params.append(param,'');
                }
                else{
                    params.append(param.substring(0,eqIndex),param.substring(eqIndex+1));
                }
            });
            updated_url+='?'+params.toString();
        }
    }
    return updated_url;
}

export const getLocaleFromLang=(lang)=>{
    switch(lang){
        case 'fi': return fiFI.components.MuiLocalizationProvider.defaultProps.localeText;
        case 'pt-BR': return ptBR.components.MuiLocalizationProvider.defaultProps.localeText;
        case 'en':
        default: return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    }
}

export function formatAppDateTime(value,locale){
    if(!value) return "";
    return dayjs(value).locale((locale||"en").toLowerCase()).format("L LT");
}

export const getCurrencyLocaleFromLang=(lang)=>{
    switch(lang){
        case 'fi': return "fi-FI";
        case 'pt-BR': return "pt-BR";
        case 'en':
        default: return "en-US";
    }
}

export const getLimitFromParams=(entityParams)=>{
  if(!Array.isArray(entityParams)) return null;
  const limitParam = entityParams.find(p=>p.startsWith('_limit='));
  if(!limitParam) return null;
  const value=parseInt(limitParam.split('=')[1],10);
  return Number.isNaN(value)?null:value;
};

export const stripPagingParams=(entityParams)=>entityParams.filter(p=>!p.startsWith('_limit=')&&!p.startsWith('_offset='));

export const patchRowLocally=(entityId,data,setRecords)=>{
    setRecords(prev=>prev.map(row=>row.id===entityId?{...row,...data}:row));
};

//Removes the detail page tabs whose name is in hiddenNames (record_rules.hidden_page_tabs from the backend)
export const filterPageTabs=(pageTabs,hiddenNames)=>{
    if(!pageTabs||!Array.isArray(hiddenNames)||hiddenNames.length===0) return pageTabs;
    return pageTabs.filter(tab=>!hiddenNames.includes(tab.name));
};

export function compressSingleFields(singleFields){
    return Object.fromEntries(Object.entries(singleFields).map(([field,data])=>[field,{value:data.value}]));
}

export const evaluateReadOnly=(readOnly,recordRules,fieldProp)=>{
    try{
        if (readOnly) return true;
        
        if(!recordRules||recordRules.can_update_record===false){
            return true;
        }
        if(fieldProp&&fieldProp.read_only!==undefined){
            return !!fieldProp.read_only;
        }
        return true;
    } 
    catch(err){
        consoleLog({file:file,context:'evaluateReadOnly',arg_name:'err',arg_value:err});
        return true;
    }
};

export const toNumber=(value)=>{
    const n=Number(value);
    return isNaN(n)?0:n;
};

// Applies a MUI DataGrid-style filterModel ({items:[{field,operator,value}]}) to an
// already-loaded plain array of records - lets client-side-loaded lists (e.g. an
// Autocomplete's option set) reuse the same pre-defined filters (listPreDefaultFilter,
// via application.globalData.filterModel) that DataGrid-backed lists apply. Only
// 'isAnyOf' is implemented since it's the only operator currently used by
// listPreDefaultFilter; items with any other/unsupported operator are left unfiltered.
export const applyFilterModel=(records,filterModel)=>{
    if(!Array.isArray(records)||!filterModel?.items?.length) return records;
    return records.filter((record)=>filterModel.items.every((item)=>{
        if(item.operator==='isAnyOf') return Array.isArray(item.value)&&item.value.includes(record?.[item.field]);
        return true;
    }));
};